import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

export class ActivateController implements ng.IController {

    static $inject: string[] = [
        '$state',
        '$stateParams',
        '$scope',
        'store',
        'ArchiSmallServices'
    ];

    constructor(
        private $state: ng.ui.IStateService,
        private $stateParams: any,
        private $scope: any,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices
    ) {
        $scope.result = 0;
        ArchiSmallServices.validateActivation($stateParams.token)
            .then((response: any) => {
                $scope.result = 1;
                store.remove('registrationJWT');
                store.remove('registeredUser');
            }, (error) => {
                $scope.result = -1;
            });
        $scope.next = () => {
            $state.go('login');
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/activate/activate.controller.ts